// 巡检上帝图记录
import React, { useEffect, useState, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { theme, Card, Tag, Table, App, Pagination, Spin } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';

import { getGodMapIndexInfo } from '@/server/godMap.js'

function GodMapTable (props) {
  const location = useLocation();
  const { dataList } = props
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('dock_token');
  const {
    token: { colorText, colorTextQuaternary },
  } = theme.useToken(); //获取主题颜色
  const { message } = App.useApp();

  const [getdataList, setGetDataList] = useState([])//获取到的数据
  const [total, setTotal] = useState(0);//总条数
  const [siftData, setSiftData] = useState({ //筛选数据
    cur: 1,
    page: 10,
    urlType: 1,
  });


  // 获取所有数据
  const getAllData = async (info) => {
    setGetDataList([])
    setLoading(true)
    let res = await getGodMapIndexInfo({
      access_token: token,
      type: info.urlType,
      page: info.cur,
      perpage: info.page,
    })
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      setLoading(false)
      return;
    }
    let list = []
    res.data.items.forEach((ele, index) => {
      let obj = {
        ...ele,
        key: `${ele.type}_${ele.id}`
      }
      list.push(obj)
    });
    setGetDataList([...list]);
    setTotal(res.data.total);
    setLoading(false);
  }
  useEffect(() => {
    let sif = siftData
    switch (location.pathname) {
      case '/godMap_conduit'://管道
        sif.urlType = 1;
        break;
      case '/godMap_powerGrid'://电网
        sif.urlType = 7;
        break;
      default:
        break;
    }
    console.log('111', location.pathname, sif.urlType);
    setSiftData({ ...sif })
    getAllData(sif);

    // eslint-disable-next-line 
  }, [location.pathname])


  //表头配置
  const columns = [
    {
      title: '单元段名称',
      dataIndex: 'title',
      render: (text, record) => {
        return (
          <div>
            {text}
          </div>
        )
      }
    },
    {
      title: '总里程(km)',
      dataIndex: 'length',
      render: (text, record) => {
        return (
          <div>
            {
              text
                ? <span>{text}</span>
                : <div style={{ color: colorTextQuaternary }}>-</div>
            }
          </div>
        )
      }
    },
    {
      title: '更新时间',
      dataIndex: 'time',
      render: (text, record) => {
        return (
          <div>
            {
              text
                ? <div>
                  <span className='marR8'>{text.split(' ')[0]}</span>
                  <span className='opa45'>{text.split(' ')[1]}</span>
                </div>
                : <div style={{ color: colorTextQuaternary }}>-</div>
            }
          </div>
        )
      }
    },
    {
      title: '上帝图',
      width: 100,
      align: 'center',
      dataIndex: 'time',
      render: (text, record) => {
        return (
          <>
            {
              Number(record.length) > 0
                ? (
                  <GlobalOutlined
                    className='pointer'
                    style={{ color: '#1668DC' }}
                    onClick={() => {
                      // window.open('./NewGodmap?' + record.id);
                      window.open(`./NewGodmap?${record.id}&${record.type}&${record.longitude}&${record.latitude}`);
                    }}
                  />
                )
                : <div style={{ color: colorTextQuaternary }}>-</div>
            }
          </>
        )
      }
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={getdataList}
        pagination={false}
        loading={loading}
        rowKey='key'
      >
      </Table>
      <div className='pdT16'>
        <Pagination align='end' current={siftData.cur} pageSize={siftData.page} total={total} showTotal={total => `共 ${total} 条数据`}
          onChange={
            (current, pageSize) => { //选择当前页后执行
              let sift = { ...siftData };
              sift.cur = current;
              sift.page = pageSize;
              setSiftData(sift);
              getAllData(sift);
            }
          } />
      </div>
    </div>
  )
}
export default GodMapTable